// extracted by mini-css-extract-plugin
export default {"fullPageDivider":"FullPageDivider_fullPageDivider__GueCy"};